<template>
  <div>
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
        <!-- 회람 -->
        <c-table
          ref="apprline2"
          title="LBL0000754"
          tableId="apprline2"
          topBorderClass="topcolor-orange"
          :columnSetting="false"
          :isFullScreen="false"
          :hideBottom="true"
          :usePaging="false"
          :filtering="false"
          gridHeight="350px"
          :columns="gridline2.columns"
          :data="gridline2.data"
          :isExcelDown="false"
        >
        </c-table>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-8 col-lg-8 col-xl-8">
        <!-- 결재이력 -->
        <c-table
          ref="apprline"
          title="LBL0000597"
          tableId="apprline"
          topBorderClass="topcolor-orange"
          :columnSetting="false"
          :isFullScreen="false"
          :hideBottom="true"
          :usePaging="false"
          :filtering="false"
          gridHeight="350px"
          :columns="gridline.columns"
          :data="gridline.data"
          :isExcelDown="false"
        >
          <template v-slot:customArea="{ props, col }">
            <template v-if="col.name === 'approvalKindName'">
              <span class="text-weight-bold" :class="getLineKindColor(props.row.approvalKindCd)">{{props.row.approvalKindName}}</span>
            </template>
            <template v-if="col.name === 'approvalStatusName'">
              <span :class="getLineKindColor2(props.row.approvalStatusName)">{{props.row.approvalStatusName}}</span>
            </template>
            <template v-if="col.name === 'click'">
              <q-btn 
                round unelevated 
                size="10px"
                color="amber" 
                icon="search"
                @click.stop="() => { rowIndex = props.rowIndex, electronSignature = props.row.electronSignature}"
                >
                <q-popup-proxy :ref="'proxy1_' + props.rowIndex" :breakpoint="400">
                  <component
                    :is="col.component"
                    :popupParam="props.row"
                    :rowIndex="props.rowIndex"
                    @callback="callback1"
                  />
                </q-popup-proxy>
              </q-btn>
            </template>
          </template>
        </c-table>
      </div>
    </div>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: 'appr-history-pop',
  props: {
    popupParam: {
      type: Object,
      default: function() {
        return {
          sysApprovalRequestId: '',
        }
      },
    },
  },
  data() {
    return {
      dragging: false,
      gridline: {
        columns: [
          {
            name: 'approvalKindName',
            field: 'approvalKindName',
            // 결재구분
            label: 'LBL0000760',
            align: 'center',
            style: 'width: 80px',
            type: 'custom',
            sortable: false,
          },
          {
            name: 'deptName',
            field: 'deptName',
            // 부서
            label: 'LBLDEPT',
            align: 'center',
            style: 'width: 120px',
            sortable: false,
          },
          {
            name: 'approvalUserName',
            field: 'approvalUserName',
            // 이름
            label: 'LBLNAME',
            align: 'center',
            type: 'html',
            style: 'width: 120px',
            sortable: false,
          },
          {
            name: 'approvalStatusName',
            field: 'approvalStatusName',
            // 결재상태
            label: 'LBL0000761',
            align: 'center',
            style: 'width: 100px',
            type: 'custom',
            sortable: false,
          },
          {
            name: 'returnReason',
            field: 'returnReason',
            // 반려사유
            label: 'LBL0000762',
            align: 'left',
            sortable: false,
          },
          {
            name: 'approvalDt',
            field: 'approvalDt',
            // 결재일시
            label: 'LBL0000763',
            align: 'center',
            style: 'width: 160px',
            sortable: false,
          },
        ],
        data: [],
      },
      gridline2: {
        columns: [
          {
            name: 'deptName',
            field: 'deptName',
            // 부서
            label: 'LBLDEPT',
            align: 'center',
            style: 'width: 40%',
            sortable: false,
          },
          {
            name: 'approvalUserName',
            field: 'approvalUserName',
            // 이름
            label: 'LBLNAME',
            align: 'center',
            style: 'width: 40%',
            sortable: false,
          },
        ],
        data: [],
      },
      editable: true,
      listUrl: '',
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  watch: {
  },
  methods: {
    init() {
      this.listUrl = selectConfig.sys.appr.line.list.url;

      // 환경설정 결재서명여부
      if (this.$store.getters.user.approveSignature === 'Y') {
        this.gridline.columns.push(
          // 서명보기
          {
            name: 'click',
            field: 'click',
            label: 'LBL0000779',
            style: 'width:70px',
            type: 'custom',
            align: 'center',
            sortable: false,
            component: () => import(`${'@/pages/sys/appr/apprSignaturePop.vue'}`)
          },
        )
      }

      this.getApprLine();
    },
    getApprLine() {
      // AKC0000001 : 상신, AKC0000002 : 합의, AKC0000003 : 결재, AKC0000004 : 확인, AKC0000009 : 회람, AKC0000010 : 재상신
      this.$http.url = this.listUrl;
      this.$http.param = {
        sysApprovalRequestId: this.popupParam.sysApprovalRequestId,
      };
      this.$http.type = 'GET';
      this.$http.request((_result) => {
        if (_result.data.length > 0) {
          let lineData1 = _result.data.filter( x => {
            return x.approvalKindCd == 'AKC0000001' || x.approvalKindCd == 'AKC0000002' || x.approvalKindCd == 'AKC0000003' || x.approvalKindCd == 'AKC0000004' || x.approvalKindCd == 'AKC0000010'
          });
          let lineData2 = _result.data.filter( x => {
            return x.approvalKindCd == 'AKC0000009'
          });
          this.gridline.data = lineData1;
          this.gridline2.data = lineData2;
        }
      },
      () => {
      });
    },
    getLineKindColor(_cd) {
      let color = '';
      // AKC0000001 : 상신, AKC0000002 : 합의, AKC0000003 : 결재, AKC0000004 : 확인, AKC0000009 : 회람, AKC0000010 : 재상신
      switch(_cd) {
        case 'AKC0000010':
        case 'AKC0000001':
          color = 'blue-grey-4';
          break;
        case 'AKC0000002':
          color = 'green-7';
          break;
        case 'AKC0000003':
          color = 'blue-7';
          break;
        case 'AKC0000004':
          color = 'blue-grey-4';
          break;
      }
      return 'text-' + color;
    },
    getLineKindColor2(_cd) {
      let color = '';
      switch(_cd) {
        case '반려':
          color = 'text-weight-bold text-red';
          break;
      }
      return color;
    },
    callback1(data, rowIndex) {
      let refName = 'proxy1_' + rowIndex;
      this.$refs[refName].hide();
    },
  },
};
</script>